/**
 * Screens at home: watching TV (an evening in front of it: rest and a bit of fun; the match is more fun with the
 * volume up), and games on the console (fun; good games, more). Time passes for real.
 */
import { advance, type LifeEvent, type LifeState } from './life.ts';

export type TvChannel = 'football' | 'news' | 'film' | 'cartoons';
export function watchTV(s: LifeState, channel: TvChannel, minutes: number): { line: string; events: LifeEvent[] } {
  const k = minutes / 60;
  s.needs.fun = Math.min(100, s.needs.fun + (channel === 'football' ? 14 : channel === 'film' ? 12 : 9) * k);
  s.needs.energy = Math.min(100, s.needs.energy + 5 * k);
  if (channel === 'news') s.skills.academics = Math.min(100, s.skills.academics + 0.15 * k);
  const line = channel === 'football' ? 'You shout at the referee twice. The neighbours shout back.'
    : channel === 'news' ? 'Old newsreel footage, the announcer very excited about everything. Oddly relaxing.'
    : channel === 'film' ? 'Everyone in it talks twice as fast as anyone has ever talked. You keep up, mostly.'
    : 'Superman punches a robot. You are not too old for this.';
  s.stats.tvHours = (s.stats.tvHours ?? 0) + k;
  return { line, events: advance(s, minutes, { busy: true }) };
}

/** A game on the console: performance 0..1 from how you played. */
export function playedGame(s: LifeState, performance: number, minutes: number): { lines: string[]; events: LifeEvent[] } {
  s.needs.fun = Math.min(100, s.needs.fun + 10 + performance * 14);
  s.needs.energy = Math.max(0, s.needs.energy - 3);
  s.stats.gamesPlayed = (s.stats.gamesPlayed ?? 0) + 1;
  if (s.stats.gamesPlayed === 1) s.history.push({ t: s.minutes, text: 'Bought a console and lost an evening to it.' });
  return { lines: [performance > 0.7 ? 'You could go pro. (You could not.)' : performance > 0.4 ? 'A decent session.' : 'The pad is clearly broken.'], events: advance(s, minutes, { busy: true }) };
}
